import classNames from 'classnames';
import React__default, { forwardRef, useState } from 'react';
import { toSpacingAttributes } from './Spacing/spacing.js';
import './Box.scss';

const Box = forwardRef(({ children, className, ariaLabel, id, margin, padding, elevation, isDisabled = false, rounding = '10', background = 'transparent', isScrollable, isPositionContainer, placement, customBackground, showOverflow = false, onClick, href, target, onMouseEnter, onMouseLeave, onFocus, }, ref) => {
    const isLink = Boolean(href);
    const [isDragging, setIsDragging] = useState(false);
    const handlePointerDown = () => {
        if (isLink) {
            setIsDragging(false);
        }
    };
    const handlePointerMove = () => {
        if (isLink) {
            setIsDragging(true);
        }
    };
    const handleClick = (e) => {
        if (!isDragging) {
            onClick?.(e);
        }
        else {
            e.preventDefault();
        }
    };
    const classes = [className];
    if (isLink) {
        classes.push('link-as-box--rev');
    }
    const spacingAttributes = {
        ...toSpacingAttributes('m', margin),
        ...toSpacingAttributes('p', padding),
    };
    const sharedProps = {
        id,
        'data-rev-component': 'box',
        'aria-disabled': isDisabled,
        inert: isDisabled,
        'data-rev-elevation': elevation,
        'data-rev-rounding': rounding,
        'data-rev-background': !customBackground && background !== 'transparent' ? background : null,
        'data-rev-scrollable': isScrollable,
        'data-rev-position-container': isPositionContainer,
        'data-rev-placement': placement,
        'data-rev-show-overflow': showOverflow,
        'aria-label': ariaLabel,
        onClick: handleClick,
        onPointerDown: handlePointerDown,
        onPointerMove: handlePointerMove,
        onMouseEnter,
        onMouseLeave,
        onFocus,
        className: classNames(classes),
        style: { '--rev-customBackground': customBackground },
        ...spacingAttributes,
    };
    if (isLink) {
        return (React__default.createElement("a", { ...sharedProps, ref: ref, href: href, target: target }, children));
    }
    return (React__default.createElement("div", { ...sharedProps, ref: ref }, children));
});
Box.displayName = 'Box';

export { Box };
//# sourceMappingURL=Box.js.map
